import simpleRestProvider from 'ra-data-simple-rest';
import axios from 'axios';
import { fetchUtils } from 'react-admin';

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  const token = localStorage.getItem('access_token');
  options.headers.set('Authorization', `Bearer ${token}`);
  return fetchUtils.fetchJson(url, options);
};

const dataProvider = simpleRestProvider(process.env.REACT_APP_API, httpClient);

const customDataProvider = {
  ...dataProvider,
  create: async (resource, params) => {
    if (resource === 'scorms' ) {
      const url = `${process.env.REACT_APP_API}/scorms/${params.data.fileName}`
      const formData = new FormData();
      formData.append('file', params.data.file.rawFile);
      const token = localStorage.getItem('access_token');
      const config = {
        headers: {
          'Authorization': `Bearer ${token}`,
          'content-type': 'multipart/form-data;boundary',
        }
      }
      return axios.post(url, formData, config);
    }
    if (resource === 'wraps') {
      console.log('entra aqui');
    }
    return dataProvider.create(resource, params);
  },
};

export default customDataProvider;